import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import moment from 'moment';
import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';
import { primary_dark15 } from '../../../shared/lib/colors';

import { loadOrders } from '../../../../redux/modules/orders';
import { payLater, canPayLater } from '../../../../redux/modules/singleOrder';

import Price from '../../../shared/Price/Price';

import './Ordini.scss';

class Ordini extends Component {
  componentWillMount() {
    this.props.loadOrders();
  }

  renderOrders(orders) {
    const { primaryColor } = this.props;

    return orders.map(order => {
      return (
        <tr key={order.id}>
          <td>#{order.id}</td>
          <td>{moment(order.date).format('DD/MM/YYYY')}</td>
          <td className="text-center">
            <Price amount={order.grandTotal} />
          </td>
          <td className="text-center">
            <span
              className="status"
              style={{ color: primary_dark15(primaryColor) }}
            >
              {order.payment.status}
            </span>
            {!!canPayLater(order) && (
              <div>
                {order.payment.typeName === 'satispay' &&
                  order.payment.satispayPaymentUrl && (
                    <a
                      className="btn btn-pay-now"
                      href={order.payment.satispayPaymentUrl}
                    >
                      Paga ora
                    </a>
                  )}
                {order.payment.typeName !== 'satispay' && (
                  <Button
                    className="btn btn-pay-now"
                    onClick={() => {
                      this.props.payLater(order.id, order.payment.typeName);
                    }}
                  >
                    Paga ora
                  </Button>
                )}
              </div>
            )}
          </td>
          <td className="text-center">
            <span
              className="status"
              style={{ color: primary_dark15(primaryColor) }}
            >
              {/* {!!order.shipping.status &&
              order.shipping.status.toLowerCase() === 'bloccato'
                ? 'In attesa'
                : order.shipping.status} */}
              {order.shipping.status}
            </span>
          </td>
          <td className="text-right">
            <Link
              to={`/ordini/dettaglio-ordine/${order.id}`}
              className="btn btn-primary"
            >
              Vedi ordine
            </Link>
          </td>
        </tr>
      );
    });
  }

  render() {
    const { siteUrl, siteName } = this.props;

    return (
      <div className="ordini">
        <Helmet
          title={'Ordini'}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita - Ordini`,
            },
            {
              name: 'keywords',
              content: `ordini, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/ordini`,
            },
          ]}
        />

        <h2 className="title-with-background">Riepilogo ordini</h2>
        {this.props.orders && this.props.orders.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>N° ordine</th>
                <th>Data</th>
                <th className="text-center">Importo</th>
                <th className="text-center">Stato pagamento</th>
                <th className="text-center">Stato spedizione</th>
                <th />
              </tr>
            </thead>
            <tbody>{this.renderOrders(this.props.orders)}</tbody>
          </table>
        ) : (
          <span>Nessun ordine trovato</span>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    orders: state.orders.data.items,
    loading: state.orders.loading,
    error: state.orders.error,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
};

export default connect(mapStateToProps, { loadOrders, payLater, canPayLater })(
  Ordini
);
